import calcCovidDose from './calcCovidDose'

export default calcCovidDose
